
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setLanguage } from '../../store/languageSlice';
import './Navbar.css';

function MainNavbar() {
  // const location = useLocation();
  const dispatch = useDispatch();
  const { selectedLanguage } = useSelector((state) => state.language);
  // const [navbarClickedSection, setNavbarClickedSection] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);
  const navbarRef = useRef(null);

  const toggleLanguage = () => {
    dispatch(setLanguage(selectedLanguage === 'en' ? 'ar' : 'en'));
  };

  // const handleNavbarClick = (section) => {
  //   setNavbarClickedSection(section);
  //   setMenuOpen(false);
  //   setTimeout(() => setNavbarClickedSection(''), 100);
  // };

  useEffect(() => {
    console.log(selectedLanguage);
  }, [selectedLanguage]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target) && menuOpen) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [menuOpen]);


  return (
    <nav ref={navbarRef} className="w-full h-[98px] bg-[#F8F9FA] px-3 md:px-[2%] lg:px-[4%] xl:px-[4%] 2xl:px-[6%]  border-b-[1px] border-[#E0DEF7] top-0 z-50">
      <div className=" px-4 sm:px-6 lg:px-8 h-full flex items-center justify-between">
        <div className="flex items-center h-full gap-3">
          <img className=" w-[100px]" src="../logo.svg" alt="logo" />
        </div>
        <div className="flex items-center gap-4">
          <button onClick={toggleLanguage} className="flex items-center gap-2 bg-[#5D4A9D1A] h-[48px] rounded-[8px] px-4 text-[#151515] text-sm font-medium">
            <img src="../loc.svg" alt="" className="w-4 h-4" />
            {selectedLanguage === 'en' ? 'العربية' : 'English'}
            {/* <img src="../arrow.svg" alt="" className="w-[11px] h-[7px]" /> */}
          </button>
         
        </div>
      </div>
     
    </nav>
  );
}

export default MainNavbar;